import swal                    from 'sweetalert2/dist/sweetalert2';
import { __ }                  from '@wordpress/i18n';

class SettingsImporterButton {
    constructor( selector: string ) {
        const importButton = jQuery( selector );

        importButton.on( 'click', ( e ) => {
            e.preventDefault();

            swal.fire( {
                title: __( 'Confirm', 'checkout-wc' ),
                text: __( 'Are you sure you want replace your current settings?', 'checkout-wc' ),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: __( 'Yes, replace my settings!', 'checkout-wc' ),
                confirmButtonColor: '#4e9ae0',
                customClass: {
                    container: 'cfw-swal-container',
                },
            } ).then( ( result ) => {
                if ( result.isConfirmed ) {
                    importButton.off( 'click' );
                    importButton.click();
                }
            } );
        } );
    }
}

export default SettingsImporterButton;
